import React from 'react';
import DifferentialItem from 'js/components/Charts/Differential/DifferentialItem';

export const QuestionSetDifferential = ({
  from,
  isStaleFrom,
  to,
  isStaleTo,
  width = 80,
  height = 100,
  yScale,
}) => {
  return (
    <DifferentialItem
      from={from?.normalizedScore}
      isStaleFrom={isStaleFrom}
      to={to?.normalizedScore}
      isStaleTo={isStaleTo}
      ticks={[]}
      arrowId={'arrow'}
      width={width}
      height={height}
      yScale={yScale}
    />
  );
};

export default QuestionSetDifferential;
